import styled, {css} from 'styled-components'
import {ifProp, switchProp} from 'styled-tools'
import {getColorFromTheme} from "../../utils/style.utils";

export interface ChipProps {
    $hasIcon?: boolean;
    $disabled?: boolean;
    $background?: string;
    $color?: string;
    $status?: "success" | "pending" | "failed"
}

export const ChipStyle = styled.div<ChipProps>`
    display: inline-flex;
    align-items: center;
    padding: 0.25rem 0.5rem;
    margin-inline-end: 0.5rem; /* 8px */
    line-height: 1.25rem; /* 20px */
    font-weight: 400;
    border-radius: 6px;
    position: relative;
    user-select: none;
    margin-top: 10px;
    background-color: ${({$background}) => $background || getColorFromTheme("green100")};

    ${switchProp("$status", {
        success: css`
            background-color: #00BD5926 !important;;

            span {
                color: #00BD59 !important;
            }
        `,
        failed: css`
            background-color: #EB2B0B26 !important;;

            span {
                color: #EB2B0B !important;;
            }
        `,
        pending: css`
            background-color: #E27D0026 !important;

            span {
                color: #E27D00 !important;
            }
        `
    })}
    span {
        color: ${({$color}) => $color || getColorFromTheme("green700")};
        font-size: calc(var(--step-0) * .65);
    }

    ${ifProp(
            "$hasIcon",
            css`
                span {
                    margin-left: 18px;
                }

                .icon {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 1.25rem;
                    height: 1.25rem;
                    left: 0.375rem;
                    display: inline-flex;
                    align-items: center;
                }
            `
    )}
    ${ifProp(
            "$disabled",
            css`
                filter: grayscale(1);
                cursor: not-allowed;
            `
    )}
`;
